import {
  Box,
  Button,
  Grid,
  makeStyles,
  Paper,
  Typography,
  TextField,
  MenuItem,
} from "@material-ui/core";
import instance from "api/globalaxios";
import Axios from "axios";
import { format } from "date-fns";
import CircularCenteredLoader from "features/common/CircularCenteredLoader";
import debounce from "lodash.debounce";
import React, { useCallback, useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import { isMuthoot } from "Routes/Routes";
import Tabs from "features/Tabs/Tabs";
import { Add, DateRangeOutlined, PrintOutlined } from "@material-ui/icons";
import DropdownButton from "Components/DropdownButton";
import DisputeRowMuthoot from "./DisputeRowMuthoot";
import { DatePickerCalendar } from "react-nice-dates";
import "react-nice-dates/build/style.css";
import { enGB } from "date-fns/locale";
import Popup from "reactjs-popup";
import { ARBITRATOR, CASE_MANAGER, MUTHOOT_SECRETARIAT, SUB_ADMIN, VENDOR, WITNESS } from "app/constants";
import { isValidNumber, isValidDate, calc_days, getDisputeStatus, getOpenClosedStatus } from 'features/disputes/MuthootDisputes/utils';
import { useMuthootRegions } from "hooks";
import validateDateAndFormat from "utils/validateDateAndFormat";
import DateRangePicker from "Components/DateRangePicker";
import fileDownload from "js-file-download";
import { Pagination } from "@material-ui/lab";
import useLoanTypes from "hooks/useLoanTypes";


const useStyles = makeStyles((theme) => ({
  root: {
    padding: "3rem",
    [theme.breakpoints.down("sm")]: {
      padding: "1.5rem",
    },
  },
  content: {
    [theme.breakpoints.down("sm")]: {
      marginTop: "3rem",
    },
  },
  searchbar: {
    border: "none",
    background: "#DADBDB",
    width: "-webkit-fill-available",
    color: "#828282",
    fontSize: "14px",
    outline: "none",
    padding: "0rem 1.5rem",
    height: "42px",
    [theme.breakpoints.down("xs")]: {
      fontSize: "12px",
      height: "34px",
      padding: "0rem 0.7rem",
    },
  },
  typeButton: {
    textTransform: "none",
    border: "1px solid #4F4F4F",
    borderRadius: "0",
    padding: "0 1.5rem",
    color: "#4F4F4F",
    backgroundColor: 'white',
    fontWeight: "400",
    fontSize: "16px",
    lineHeight: "18px",
    height: "42px",

    [theme.breakpoints.down("xs")]: {
      height: "34px",
      fontSize: "14px",
    },
  },
  typeButtonBlue: {
    textTransform: "none",
    border: "1px solid",
    borderColor: theme.palette.primary.main,
    background: isMuthoot ? theme.palette.primary.main : "#2F80ED",
    borderRadius: "0",
    padding: "0 1.5rem",
    color: "#fff",
    // fontFamily: `'Inter',sans-serif`,
    fontWeight: "400",
    fontSize: "16px",
    lineHeight: "18px",
    height: "42px",
    "&:hover": {
      background: "#FFFFFF",
      color: isMuthoot ? theme.palette.primary.main : "#2F80ED",
      border: "1px solid",
      borderColor: theme.palette.primary.main,
    },
    [theme.breakpoints.down("xs")]: {
      height: "34px",
      fontSize: "14px",
    },
  },
  typechoices: {
    color: "#333333",
    fontFamily: `'Inter',sans-serif`,
    fontWeight: "400",
    fontSize: "14px",
    lineHeight: "18px",
    textTransform: "capitalize",
    paddingRight: "5px",
    [theme.breakpoints.down("xs")]: {
      fontSize: "12px",
    },
  },
  typeFormControl: {
    margin: 0,
    "&:hover": {
      background: "#E0E0E0",
    },
  },
  spaceBox: {
    height: "4rem",
    [theme.breakpoints.down("sm")]: {
      height: "3rem",
    },
    [theme.breakpoints.down("xs")]: {
      height: "2rem",
    },
  },
  griditem: {
    padding: "8px",
    [theme.breakpoints.down("xs")]: {
      padding: "4px",
    },
  },
  title: {
    fontFamily: 'Satoshi-Bold',
    fontSize: "14px",
    lineHeight: "17px",
    [theme.breakpoints.down("sm")]: {
      fontSize: "0.9rem",
      lineHeight: "1.2rem",
    },
  },
  value: {
    fontSize: "14px",
    lineHeight: "17px",
    textTransform: "capitalize",
    "&:hover": {
      background: "#E0E0E0",
    },
    [theme.breakpoints.down("sm")]: {
      fontSize: "0.9rem",
      lineHeight: "1.2rem",
    },
  },
  titlePaper: {
    padding: "1.5rem",
    boxShadow: "none",
    width: "100%",
    backgroundColor: "initial",
    [theme.breakpoints.down("sm")]: {
      textAlign: "center",
    },
  },
  valuePaper: {
    padding: "1.5rem",
    cursor: "pointer",
    boxShadow: "none",
    width: "100%",
    border: "1px solid #E0E0E0",
    "&:hover": {
      background: "#E0E0E0",
    },
    [theme.breakpoints.down("sm")]: {
      textAlign: "center",
    },
  },
  tabsContainer: {
    width: '70%',
    flexWrap: 'nowrap',
    [theme.breakpoints.down("sm")]: {
      width: '100%',
      flexWrap: 'wrap',
    },
  },
  selected: {
    padding: "0.8rem 1.2rem",
    cursor: 'pointer',
    fontSize: '1.2rem',
    fontFamily: 'Satoshi-Medium',
    minWidth: 'fit-content',
    width: '16.6%',
    textAlign: 'center',
    whiteSpace: 'pre-line',
    color: theme.palette.primary.main,
    borderBottom: `2px solid ${theme.palette.primary.main}`,
  },
  unselected: {
    fontSize: '1.2rem',
    padding: "0.8rem 1.2rem",
    cursor: "pointer",
    fontFamily: 'Satoshi-Medium',
    minWidth: 'fit-content',
    width: '16.6%',
    textAlign: 'center',
    whiteSpace: 'pre-line',
    borderBottom: '2px solid black',
  },
  filtersContainer: {
    padding: '1rem 0',
    display: 'flex',
    gap: '15px',
    justifyContent: 'center',
    width: '100%',
    margin: 'auto',
  },
  buttonPrint: {
    border: '1px solid #AAAFB9',
    background: '#fff',
    padding: '0.5rem 1rem',
  },
  filterTypeButton: {
    padding: '0.5rem 1rem',
    border: '1px solid #AAAFB9',
    background: '#fff',
    cursor: 'pointer',
    fontSize: '14px',
    borderRadius: '4px',
    marginRight: '0.5rem',
    transition: 'all 0.3s ease',
    '&:hover': {
      background: '#f5f5f5',
    },
  },
  filterTypeButtonActive: {
    padding: '0.5rem 1rem',
    border: `1px solid ${theme.palette.primary.main}`,
    background: theme.palette.primary.main,
    color: '#fff',
    cursor: 'pointer',
    fontSize: '14px',
    borderRadius: '4px',
    marginRight: '0.5rem',
    fontWeight: '500',
  },
  filterSection: {
    padding: '1rem 0',
    borderBottom: '1px solid #E0E0E0',
    marginBottom: '1rem',
  },
  monthYearContainer: {
    display: 'flex',
    gap: '1rem',
    alignItems: 'center',
    marginTop: '1rem',
    flexWrap: 'wrap',
  },
}));


export default function DisputesMuthoot({
  count,
  disputesLoading,
  setType,
  type,
  disputes,
  reload,
  totalPages,
  page,
  setPage,
  getUserDataAnotherPage,
  region,
  setRegion,
  days,
  setDays,
  profile,
  product,
  setProduct,
  grievanceType,
  setGrievanceType,
}) {
  const classes = useStyles();
  const history = useHistory();
  const dispatch = useDispatch();
  const IS_ADMIN = profile?.profile?.profile_type === SUB_ADMIN;
  const IS_GRO = profile?.profile?.profile_type === VENDOR;
  const IS_REGIONAL_OFFICER = profile?.profile?.profile_type === MUTHOOT_SECRETARIAT;
  const IS_PNO = profile?.profile?.profile_type === CASE_MANAGER;
  const IS_IO = profile?.profile?.profile_type === ARBITRATOR;
  const IS_CALL_EXECUTIVE = profile?.profile?.profile_type === WITNESS;
  const { regions } = useMuthootRegions(!IS_REGIONAL_OFFICER);
  const { loanTypes } = useLoanTypes(isMuthoot);

  const [searchText, setSearchText] = useState("");
  const [disputesBySearch, setDisputesBySearch] = useState(disputes);
  const [cancelToken, setCancelToken] = useState();
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [filterType, setFilterType] = useState("dateRange"); // "dateRange", "month", "year"
  const [selectedMonth, setSelectedMonth] = useState(null);
  const [selectedYear, setSelectedYear] = useState(null);
  let firstname = "";
  let lastname = "";

  const debouceSearch = useCallback(debounce(search, 500), [disputes]);

  useEffect(() => {
    setDisputesBySearch(disputes);
  }, [disputes]);

  function search(value, type) {
    //Check if there are any previous pending requests
    if (typeof cancelToken != typeof undefined) {
      cancelToken.cancel("Operation canceled due to new request.");
    }
    //Save the cancel token for the current request
    let x = Axios.CancelToken.source();
    setCancelToken(x);

    if (value.trim() != "") {
      let new_value = value.replaceAll('/', '-');
      let ar = new_value.trim().split("-");
      let date = new Date(ar[1] + "/" + ar[0] + "/" + ar[2]);
      if (isValidDate(date)) {
        dispatch(getMuthootdatabydate(date, x, type, region));
      } else if (isValidNumber(new_value.trim())) {
        dispatch(getMuthootdatabyDisputeId(new_value.trim(), x, type, region, days));
      } else {
        let safePath = encodeURIComponent(new_value.trim()).replaceAll('.', '%252E');
        dispatch(getMuthootdatabyname(safePath, x, type, region, days));
      }
    } else {
      setDisputesBySearch(disputes);
    }
  }

  function getMuthootdatabyname(name, cancelToken, type, region, days) {
    return async (dispatch) => {
      try {
        const answer_array = name.split(" ");
        firstname = answer_array[0];
        lastname = answer_array[1];
        if (firstname != "" && (lastname == "" || !lastname)) {
          const response2 = await instance.get(
            `/api/MuthootsearchView/${firstname}/${null}/?type=${type}&region=${region}&days=${days}`,
            { cancelToken: cancelToken.token }
          );
          console.log(response2.data);
          setDisputesBySearch(response2.data);

          return response2.data;
        } else {
          const response3 = await instance.get(
            `/api/MuthootsearchView/${firstname}/${lastname}/?type=${type}&region=${region}&days=${days}`,
            { cancelToken: cancelToken.token }
          );
          setDisputesBySearch(response3.data);
          return response3.data.profiles;
        }
      } catch (error) {
        console.log(error);
      }
    };
  }

  function getMuthootdatabydate(date, cancelToken, type = null, region = null) {
    return async (dispatch) => {
      try {
        const response = await instance.get(
          `api/muthootsearchbydateView/${format(
            date,
            "dd-MM-yyyy"
          )}/?type=${type}&region=${region}`,
          { cancelToken: cancelToken.token }
        );
        setDisputesBySearch(response.data);

        return response.data;
      } catch (error) {
        console.log(error);
      }
    };
  }

  function getMuthootdatabyDisputeId(value, cancelToken, type, region, days) {
    return async (dispatch) => {
      try {
        const response = await instance.get(
          `/api/muthootsearchbydisputeidView/${value}/?type=${type}&region=${region}&days=${days}`,
          { cancelToken: cancelToken.token }
        );
        setDisputesBySearch(response.data);

        return response.data;
      } catch (error) {
        console.log(error);
      }
    };
  }

  const tabs = [
    {
      id: "totalcases",
      label: "Total Complaints\n " + count.registered.total,
    },
    {
      id: "closed",
      label: "Closed\n " + count.registered.closed,
    },
    {
      id: "registered",
      label: "Open\n " + count.registered.registered,
    },
    {
      id: "Loans_and_Advances",
      label: "Loans and Advances\n " + count.received.Loans_and_Advances,
    },
    // {
    //   id: "Para_Banking",
    //   label: "Para Banking\n " + count.received.Para_Banking,
    // },
    // {
    //   id: "Other_Products_and_Services",
    //   label: "Others\n " + count.received.Other_Products_and_Services,
    // },

  ];

  const [currentTab, setCurrentTab] = useState(type);
  const [daysButtonText, setDaysButtonText] = useState(null);
  const [openDatePicker, setOpenDatePicker] = useState(false);

  const handleCloseDatePicker = () => {
    setOpenDatePicker(false);
  }

  const handleTabChange = (newValue) => {
    setCurrentTab(newValue);
    setType(newValue);
    setSearchText("");
    sessionStorage.setItem("muthoot-type", newValue);
    setPage(1);
    // reload(newValue, region, days);
    // setPagination({
    //   page: 1,
    //   count: activities?.count,
    //   next: activities?.next,
    //   previous: activities?.previous,
    // });
  };

  const handleClickRegionOption = (selectedOption) => {
    const value = selectedOption?.value || selectedOption?.title || selectedOption;
    setRegion(value === region ? null : value);
  }

  const handleClickDateOption = (selectedOption) => {
    const value = selectedOption?.value || selectedOption?.title;
    if (value !== days) {
      if (value === 'selectDate') {
        setOpenDatePicker(true);
      }
      else {
        setDays(value);
        setDaysButtonText(selectedOption.title);
      }
    }
    else {
      setDays(null);
      setDaysButtonText(null);
    }
  }

  const handleClickProuctOption = (selectedOption) => {
    const value = selectedOption?.value || selectedOption?.title || selectedOption;
    if (value === product) {
      setProduct(null);
    } else {
      setProduct(value);
    }
  }

  const handleClickGrievanceTypeOption = (selectedOption) => {
    const value = selectedOption?.value || selectedOption?.title || selectedOption;
    if (value === grievanceType) {
      setGrievanceType(null);
    } else {
      setGrievanceType(value);
    }
  }

  const grievanceTypeOptions = [
    { title: 'Query', value: 'Query' },
    { title: 'Request', value: 'Request' },
    { title: 'Complaint', value: 'Complaint' },
  ];

  const handleSelectDate = (value) => {
    setDaysButtonText(format(new Date(value), "dd-MM-y"));
    setDays(calc_days(value));
    handleCloseDatePicker();
  }

  const dateOptions = [
    {
      title: 'Last 1 day',
      value: 1,
    },
    {
      title: 'Last 7 days',
      value: 7,
    },
    {
      title: 'Last 1 Month',
      value: 30,
    },
    {
      title: 'Last 3 Month',
      value: 60,
    },
    {
      title: 'Select Custom Date',
      value: 'selectDate',
      endIcon: <DateRangeOutlined style={{ color: '#343434', fontSize: '1.2rem' }} />
    },
  ];

  const monthOptions = [
    { title: 'January', value: 1 },
    { title: 'February', value: 2 },
    { title: 'March', value: 3 },
    { title: 'April', value: 4 },
    { title: 'May', value: 5 },
    { title: 'June', value: 6 },
    { title: 'July', value: 7 },
    { title: 'August', value: 8 },
    { title: 'September', value: 9 },
    { title: 'October', value: 10 },
    { title: 'November', value: 11 },
    { title: 'December', value: 12 },
  ];

  const currentYear = new Date().getFullYear();
  const startYear = 2020;
  const yearOptions = Array.from({ length: currentYear - startYear + 1 }, (_, i) => ({
    title: (currentYear - i).toString(),
    value: currentYear - i,
  }));


  async function download_MIS_Report(startDate, endDate, params = {}, filterMode = 'dateRange') {
    return instance({
      method: 'get',
      url: `api/muthootmisreport/?start_date=${startDate}&end_date=${endDate}`,
      params: params,
      responseType: 'blob'
    })
  }

  const handleDownloadReport = () => {
    // Validation based on filter type
    if (filterType === 'dateRange') {
      if (!startDate || !endDate) {
        alert("Please select both start and end dates.");
        return;
      }
      if (startDate > endDate) {
        alert("From date should be less than or equal to To date.");
        return;
      }
    } else if (filterType === 'month') {
      if (!selectedMonth || !selectedYear) {
        alert("Please select both month and year.");
        return;
      }
    } else if (filterType === 'year') {
      if (!selectedYear) {
        alert("Please select a year.");
        return;
      }
    }

    const params = {
      type: currentTab,
      region: region,
      days: days,
      product: product,
      grievance_type: grievanceType,
    };

    let fileName = 'MIS_Report';
    let reportStartDate = startDate;
    let reportEndDate = endDate;
    const today = new Date();

    if (filterType === 'dateRange') {
      reportStartDate = validateDateAndFormat(startDate, 'dd-MM-yyyy');
      reportEndDate = validateDateAndFormat(endDate, 'dd-MM-yyyy');
      fileName = `MIS_Report_${reportStartDate}_to_${reportEndDate}.xlsx`;
    } else if (filterType === 'month') {
      // Calculate start and end date for the selected month
      const monthStart = new Date(selectedYear, selectedMonth - 1, 1);
      let monthEnd = new Date(selectedYear, selectedMonth, 0);

      // Don't allow future dates - cap at today
      if (monthEnd > today) {
        monthEnd = today;
      }

      reportStartDate = validateDateAndFormat(monthStart, 'dd-MM-yyyy');
      reportEndDate = validateDateAndFormat(monthEnd, 'dd-MM-yyyy');
      const monthName = monthOptions.find(m => m.value === selectedMonth)?.title || selectedMonth;
      fileName = `MIS_Report_${monthName}_${selectedYear}.xlsx`;
    } else if (filterType === 'year') {
      // Calculate start and end date for the selected year
      const yearStart = new Date(selectedYear, 0, 1);
      let yearEnd = new Date(selectedYear, 11, 31);

      // Don't allow future dates - cap at today
      if (yearEnd > today) {
        yearEnd = today;
      }

      reportStartDate = validateDateAndFormat(yearStart, 'dd-MM-yyyy');
      reportEndDate = validateDateAndFormat(yearEnd, 'dd-MM-yyyy');
      fileName = `MIS_Report_${selectedYear}.xlsx`;
    }

    download_MIS_Report(reportStartDate, reportEndDate, params, 'dateRange')
      .then((res) => {
        fileDownload(res.data, fileName);
      })
      .catch((error) => {
        console.log(error);
        alert("Error downloading report. Please try again.");
      });
  }


  return (
    <>
      <Grid container className={classes.root}>
        <Grid container justify="space-between" alignItems="center" style={{ gap: '1rem' }}>
          <Tabs
            tabs={tabs}
            handleClickTab={handleTabChange}
            choice={currentTab}
            tabsClasses={{
              selected: classes.selected,
              unselected: classes.unselected,
            }}
            tabsContainerClass={(IS_GRO || IS_ADMIN || IS_CALL_EXECUTIVE || IS_REGIONAL_OFFICER || IS_PNO) ? classes.tabsContainer : { width: '100%' }}
          />
          {(IS_GRO || IS_ADMIN || IS_CALL_EXECUTIVE || IS_REGIONAL_OFFICER || IS_PNO) && (
            <Box>
              <Button
                variant="contained"
                color="primary"
                startIcon={<Add />}
                onClick={() => {
                  history.push("/intro");
                }}
              >
                CREATE TICKET
              </Button>
            </Box>
          )}
        </Grid>
        <Box className={classes.spaceBox} />
        {disputesLoading ? (
          <CircularCenteredLoader />
        ) : (
          <>
            <Grid container>
              <Grid
                item
                className={classes.griditem}
                style={{ paddingLeft: 0, flex: 1, }}
              >
                <input
                  type="text"
                  placeholder="Search by Complainant's Name, Date (DD-MM-YYYY) or G.ID"
                  value={searchText}
                  onChange={(e) => {
                    setSearchText(e.target.value);
                    debouceSearch(e.target.value, type);
                  }}
                  onBlur={(e) => {
                    e.target.placeholder =
                      "Search by Complainant's Name, Date (DD-MM-YYYY) or G.ID";
                  }}
                  className={classes.searchbar}
                  onFocus={(e) => (e.target.placeholder = "")}
                />
              </Grid>
              {!IS_REGIONAL_OFFICER && (
                <Grid item className={classes.griditem}>
                  <DropdownButton
                    buttonText={region ? region : 'Region'}
                    options={regions}
                    classes={classes}
                    handleClickOption={handleClickRegionOption}
                    selectedOption={region}
                  />
                </Grid>
              )}
              <Grid item className={classes.griditem}>
                <DropdownButton
                  buttonText={daysButtonText ? daysButtonText : 'Date'}
                  classes={classes}
                  options={dateOptions}
                  handleClickOption={handleClickDateOption}
                  selectedOption={days}
                />
              </Grid>
              <Grid item className={classes.griditem}>
                <DropdownButton
                  buttonText={product ? product : 'Product'}
                  classes={classes}
                  options={loanTypes}
                  handleClickOption={handleClickProuctOption}
                  selectedOption={product}
                />
              </Grid>
              <Grid item className={classes.griditem}>
                <DropdownButton
                  buttonText={grievanceType ? grievanceType : 'Type'}
                  classes={classes}
                  options={grievanceTypeOptions}
                  handleClickOption={handleClickGrievanceTypeOption}
                  selectedOption={grievanceType}
                />
              </Grid>
            </Grid>
            {(
              <>
                <Box className={classes.filterSection} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-end', gap: '1rem', width: '100%' }}>
                  <div>
                    <TextField
                      select
                      size="small"
                      variant="outlined"
                      label="Report Filter Type"
                      value={filterType}
                      onChange={(e) => {
                        const newType = e.target.value;
                        setFilterType(newType);
                        setStartDate(null);
                        setEndDate(null);
                        setSelectedMonth(null);
                        setSelectedYear(null);
                      }}
                      style={{ minWidth: '180px' }}
                    >
                      <MenuItem value="dateRange">Date Range</MenuItem>
                      <MenuItem value="month">Month-wise</MenuItem>
                      <MenuItem value="year">Year-wise</MenuItem>
                    </TextField>
                  </div>
                  <Box style={{ display: 'flex', gap: '1rem', alignItems: 'stretch', flexWrap: 'wrap', width: '100%' }}>
                    {filterType === 'dateRange' && (
                      <>
                        <DateRangePicker
                          startDate={startDate}
                          setStartDate={setStartDate}
                          endDate={endDate}
                          setEndDate={setEndDate}
                          maximumStartDate={new Date()}
                          maximumEndDate={new Date()}
                        />
                        <Button
                          className={classes.buttonPrint}
                          endIcon={<PrintOutlined />}
                          onClick={handleDownloadReport}
                          disabled={!startDate || !endDate}
                          size="small"
                        >
                          Download Report
                        </Button>
                      </>
                    )}

                    {filterType === 'month' && (
                      <>
                        <TextField
                          select
                          size="small"
                          variant="outlined"
                          label="Select Month"
                          value={selectedMonth || ''}
                          onChange={(e) => setSelectedMonth(e.target.value || null)}
                          style={{ minWidth: '150px', flex: '1' }}
                        >
                          <MenuItem value="">Clear</MenuItem>
                          {monthOptions.map(option => (
                            <MenuItem key={option.value} value={option.value}>{option.title}</MenuItem>
                          ))}
                        </TextField>
                        <TextField
                          select
                          size="small"
                          variant="outlined"
                          label="Select Year"
                          value={selectedYear || ''}
                          onChange={(e) => setSelectedYear(e.target.value || null)}
                          style={{ minWidth: '150px', flex: '1' }}
                        >
                          <MenuItem value="">Clear</MenuItem>
                          {yearOptions.map(option => (
                            <MenuItem key={option.value} value={option.value}>{option.title}</MenuItem>
                          ))}
                        </TextField>
                        <Button
                          className={classes.buttonPrint}
                          endIcon={<PrintOutlined />}
                          onClick={handleDownloadReport}
                          disabled={!selectedMonth || !selectedYear}
                          size="small"
                        >
                          Download Report
                        </Button>
                      </>
                    )}

                    {filterType === 'year' && (
                      <>
                        <TextField
                          select
                          size="small"
                          variant="outlined"
                          label="Select Year"
                          value={selectedYear || ''}
                          onChange={(e) => setSelectedYear(e.target.value || null)}
                          style={{ minWidth: '150px', flex: '1' }}
                        >
                          <MenuItem value="">Clear</MenuItem>
                          {yearOptions.map(option => (
                            <MenuItem key={option.value} value={option.value}>{option.title}</MenuItem>
                          ))}
                        </TextField>
                        <Button
                          className={classes.buttonPrint}
                          endIcon={<PrintOutlined />}
                          onClick={handleDownloadReport}
                          disabled={!selectedYear}
                          size="small"
                        >
                          Download Report
                        </Button>
                      </>
                    )}
                  </Box>
                </Box>
              </>
            )}
            {/* Disputes list starts from here */}
            <Box className={classes.spaceBox}></Box>
            <Grid container style={{ rowGap: "8px" }}>
              <Paper className={classes.titlePaper} square>
                <Grid container spacing={2} justifyContent="flex-start">
                  <>
                    <Grid item xs sm={1}>
                      <div style={{ display: 'flex', alignItems: 'center' }}>
                        <Typography className={classes.title}>
                          G. ID
                        </Typography>
                      </div>
                    </Grid>
                    <Grid item xs sm={2}>
                      <Typography className={classes.title}>
                        Name
                      </Typography>
                    </Grid>
                    <Grid item xs sm={3}>
                      <Typography className={classes.title}>
                        COMPLAINT DETAILS
                      </Typography>
                    </Grid>
                    <Grid item xs sm={1}>
                      <Typography className={classes.title} style={{ textAlign: 'center' }}>
                        Stage
                      </Typography>
                    </Grid>
                    <Grid item xs sm={1}>
                      <Typography className={classes.title} style={{ textAlign: 'center' }}>
                        Status
                      </Typography>
                    </Grid>
                    <Grid item xs sm={1}>
                      <Typography className={classes.title} style={{ textAlign: 'center' }}>
                        Complaint Category
                      </Typography>
                    </Grid>
                    <Grid item xs sm={1}>
                      <Typography className={classes.title} style={{ textAlign: 'center' }}>
                        Days Passed
                      </Typography>
                    </Grid>
                    <Grid item xs sm={2}>
                      <Typography className={classes.title} style={{ textAlign: 'left' }}>
                        Date & Time
                      </Typography>
                    </Grid>
                  </>
                </Grid>
              </Paper>
              {disputesBySearch.length !== 0 ? (
                disputesBySearch.map((dispute) => {
                  return (
                    <DisputeRowMuthoot
                      id={dispute.id}
                      name={dispute.name}
                      filingDate={dispute.created}
                      registrationDate={dispute.approved_date}
                      history={history}
                      complaint_category={dispute.summery}
                      stage={getDisputeStatus(dispute?.muthoot_status)}
                      status={getOpenClosedStatus(dispute?.status)}
                      action_due={calc_days(dispute.created)}
                      complaint_details={dispute.description}
                      closedDate={dispute?.date_closed_by_grc}
                      currentTab={currentTab}
                    />
                  );
                })
              ) : (
                <Grid container justifyContent="center">
                  <Grid item>
                    <Box textAlign="center">
                      <Typography
                        style={{
                          fontWeight: 500,
                          fontSize: "initial",
                        }}
                      >
                        Dispute does not exist.
                      </Typography>
                    </Box>
                  </Grid>
                </Grid>
              )}
            </Grid>
            <Box height="10px"></Box>
            {disputesBySearch.length !== 0 && !searchText && (
              <div style={{ display: 'flex', justifyContent: 'right', padding: '1rem 0', width: '100%' }}>
                <Pagination color="primary" page={page} count={totalPages} onChange={(event, value) => getUserDataAnotherPage(value)} />
              </div>
            )}
          </>
        )}
      </Grid>

      <Popup
        open={openDatePicker}
        onClose={handleCloseDatePicker}
        anchorOrigin={{
          vertical: 'center',
          horizontal: 'center',
        }}
        transformOrigin={{
          vertical: 'center',
          horizontal: 'center',
        }}
      >
        <DatePickerCalendar
          locale={enGB}
          // date={isValidDate(daysButtonText) ? new Date(daysButtonText) : new Date()}
          onDateChange={handleSelectDate}
        />
      </Popup>
    </>
  );
}
